
export const decielen = {
  SparkCity: {
    D1: {
      "2020": 0.017,
      "2021": 0.019,
      "2022": 0.022,
      "2023": 0.027,
      "2024": 0.032,
      "2025": 0.037,
      "2026": 0.055,
      "2027": 0.072,
      "2028": 0.094,
      "2029": 0.124,
      "2030": 0.156
    },
    D2: {
      "2020": 0.018,
      "2021": 0.021,
      "2022": 0.026,
      "2023": 0.032,
      "2024": 0.041,
      "2025": 0.050,
      "2026": 0.070,
      "2027": 0.085,
      "2028": 0.113,
      "2029": 0.140,
      "2030": 0.182
    },
    D3: {
      "2020": 0.024,
      "2021": 0.034,
      "2022": 0.041,
      "2023": 0.054,
      "2024": 0.065,
      "2025": 0.089,
      "2026": 0.110,
      "2027": 0.133,
      "2028": 0.161,
      "2029": 0.207,
      "2030": 0.257
    },
    D4: {
      "2020": 0.026,
      "2021": 0.037,
      "2022": 0.045,
      "2023": 0.060,
      "2024": 0.073,
      "2025": 0.098,
      "2026": 0.115,
      "2027": 0.145,
      "2028": 0.180,
      "2029": 0.220,
      "2030": 0.274
    },
    D5: {
      "2020": 0.035,
      "2021": 0.051,
      "2022": 0.065,
      "2023": 0.080,
      "2024": 0.094,
      "2025": 0.133,
      "2026": 0.145,
      "2027": 0.180,
      "2028": 0.224,
      "2029": 0.285,
      "2030": 0.331
    }
  },
  // The NAL Model
  NAL: {
    D1: {
      "2020": 0.0170,
      "2021": 0.0190,
      "2022": 0.0220,
      "2023": 0.0243,
      "2024": 0.0272,
      "2025": 0.0310,
      "2026": 0.0433,
      "2027": 0.0567,
      "2028": 0.0740,
      "2029": 0.0976,
      "2030": 0.1228
    },
    D2: {
      "2020": 0.0180,
      "2021": 0.0210,
      "2022": 0.0260,
      "2023": 0.0300,
      "2024": 0.0349,
      "2025": 0.0410,
      "2026": 0.0551,
      "2027": 0.0669,
      "2028": 0.0890,
      "2029": 0.1102,
      "2030": 0.1433
    },
    D3: {
      "2020": 0.0240,
      "2021": 0.0340,
      "2022": 0.0410,
      "2023": 0.0486,
      "2024": 0.0553,
      "2025": 0.0701,
      "2026": 0.0866,
      "2027": 0.1047,
      "2028": 0.1267,
      "2029": 0.1629,
      "2030": 0.2023
    },
    D4: {
      "2020": 0.0260,
      "2021": 0.0370,
      "2022": 0.0450,
      "2023": 0.0540,
      "2024": 0.0621,
      "2025": 0.0771,
      "2026": 0.0905,
      "2027": 0.1141,
      "2028": 0.1417,
      "2029": 0.1732,
      "2030": 0.2157
    },
    D5: {
      "2020": 0.0350,
      "2021": 0.0510,
      "2022": 0.0650,
      "2023": 0.0720,
      "2024": 0.0799,
      "2025": 0.0905,
      "2026": 0.1141,
      "2027": 0.1417,
      "2028": 0.1763,
      "2029": 0.2243,
      "2030": 0.2606
    }
  }
}